import { duplicateMenu } from 'src/api';
import { IDuplicateMenuRequest, IDuplicateMenuResponse } from 'src/api/types';
import { SnackbarStatus } from '@weareopenr/component-library';
import { SnackbarContextValue } from '@weareopenr/component-library/build/components/Snackbar/types';
import { boldMenuName } from 'src/helpers/truncateMenuName/boldMenuName';

export const duplicateMenuOnSubmit = async (
  menuId: string,
  payload: IDuplicateMenuRequest,
  closeModal: () => void,
  showSnackbar: SnackbarContextValue['showSnackbar'],
  navigate: (value: string) => void,
  pathname: string,
) => {
  showSnackbar({
    status: SnackbarStatus.INFO,
    message: 'Menu duplication in progress…',
  });

  try {
    const res: Response = await duplicateMenu(menuId, payload);
    const json = await res.json();
    const menu: IDuplicateMenuResponse['data'] = json.data[0];
    showSnackbar({
      status: SnackbarStatus.SUCCESS,
      message: <>Menu {boldMenuName(menu.name)} has been created as a duplicate.</>,
    });

    if (pathname === `/menus/${menuId}`) {
      navigate(`/menus/${menu.menu_id}`);
    }
    closeModal();
  } catch (e) {
    showSnackbar({
      status: SnackbarStatus.ERROR,
      message: 'We have been unable to complete your request. Please try again',
    });
    throw e;
  }
};
